import React, { Component } from 'react';
import { Link } from 'gatsby';
import ScrollAnimation from 'react-animate-on-scroll';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default class StickyNav extends Component {
  render() {
    return (
      <ScrollAnimation
        className='sticky-nav fadeInUp delay-3s'
        duration={2}
        animateOnce={true}
      >
        <Slider
          className='sticky-nav-slider'
          slidesToShow={3}
          swipeToSlide={true}
          infinite={true}
          arrows={false}
        >
          <Link to='/'>Home</Link>
          <Link to='/essentials'>Features</Link>
          <Link to='/pricing'>Pricing</Link>
          <Link to='/templates'>Templates</Link>
          <Link to='/our-story'>Our Story</Link>
        </Slider>
      </ScrollAnimation>
    );
  }
}
